import { render, staticRenderFns } from "./AppointmentGenderChart.vue?vue&type=template&id=ab4b91fe&"
import script from "./AppointmentGenderChart.vue?vue&type=script&lang=js&"
export * from "./AppointmentGenderChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports